export const EVENT_INTERACTION = 'EventInteraction';
export enum EventInteractions {
    Impression = 'impression',
    Click = 'click',
    Hover = 'hover',
}
